import React from "react";
import { Box, Typography } from "@mui/material";
import { useQuery } from "@apollo/client";
import { DOOR_LIST } from "graphql/doorQuery";
import Toaster from "common/Toaster";
import CButton from "common/CButton";
import { useState } from "react";

const DoorAccess = () => {
  const [requestLoading, setRequestLoading] = useState(false);
  const [requestedDoor, setRequestedDoor] = useState("");

  const { loading, data, error } = useQuery(DOOR_LIST, {
    onError: (err) => {
      Toaster({
        message: "Failed to fetch available door",
        type: "error",
      });
    },
  });

  const handleDoorOpen = (item) => {
    setRequestLoading(true);
    setRequestedDoor(item.doorInfo);

    fetch(item.ipAddress)
      .then((res) => {
        if (res.status === 200) {
          Toaster({
            message: "Door Opened!",
            type: "success",
          });
        }
      })
      .catch((err) => {
        Toaster({
          message: err.message,
          type: "error",
        });
      })
      .finally(() => {
        setRequestLoading(false);
        setRequestedDoor("");
      });
  };

  return (
    <Box>
      {!loading &&
        data &&
        data?.registeredDoors?.edges.map((item, idx) => {
          return (
            <Box
              key={`${item?.node?.doorInfo}_${idx}`}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderWidth: 1,
                marginBottom: "10px",
              }}
            >
              <Typography sx={{ fontWeight: 600 }}>
                {item?.node?.doorInfo}
              </Typography>
              <CButton
                label={"Open Door"}
                style={{ width: 90, fontSize: "13px" }}
                size="small"
                onClick={() => handleDoorOpen(item.node)}
                isLoading={
                  requestLoading && requestedDoor === item?.node?.doorInfo
                }
              />
            </Box>
          );
        })}
    </Box>
  );
};

export default DoorAccess;
